import { render, staticRenderFns } from "./sentPostDetail.vue?vue&type=template&id=5face1b8"
import script from "./sentPostDetail.vue?vue&type=script&lang=js"
export * from "./sentPostDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports